<template>
  <div class="checkout-process">
    <ul>
      <li
        :class="[
          'step passed zero-step',
          { clickable: editable, active: step2 },
        ]"
        @click="editable ? $emit('editData') : null"
      >
        <i v-if="step2345678" class="fas fa-check" />
        <i v-else class="number">1</i>
        <p>Ihre Daten</p>
      </li>
      <li :class="['arrow', { 'half-active': step1, active: step2345678 }]" />
      <li
        :class="[
          'step step-one',
          { passed: step345678, active: step21 || step2, clickable: editable },
        ]"
        @click="editable ? $emit('editWarranty') : null"
      >
        <i v-if="step345678" class="fas fa-check" />
        <i v-else class="number">2</i>
        <p>Garantie & Versicherung</p>
      </li>
      <li :class="['arrow', { 'half-active': step21, active: step345678 }]" />


      <li
        :class="[
          'step step-one',
          { passed: step45678, active: step3, clickable: editable },
        ]"
        @click="editable ? $emit('editFinancing') : null"
      >
        <i v-if="step45678" class="fas fa-check" />
        <i v-else class="number">3</i>
        <p>Zahlart</p>
      </li>
      <li :class="['arrow', { 'half-active': step3, active: step45678 }]" />

      <li
        :class="[
          'step step-two',
          { passed: step567, active: step441, clickable: editable },
        ]"
        @click="editable ? $emit('editApproval') : null"
      >
        <i v-if="step567" class="fas fa-check" />
        <i v-else class="number">4</i>
        <p>Zulassung & Lieferung</p>
      </li>
      <li :class="['arrow', { 'half-active': step41, active: step567 }]" />

      <li
        :class="[
          'step step-three',
          { passed: step67, active: step5, clickable: editable },
        ]"
        @click="editable ? $emit('editContact') : null"
      >
        <i v-if="step67" class="fas fa-check" />
        <i v-else class="number">5</i>
        <p>Kontaktpräferenz</p>
      </li>
      <li :class="['arrow', { 'half-active': step5, active: step67 }]" />
      <li
        :class="[
          'step step-four',
          { passed: step7 || finishedStep, active: step6, clickable: editable },
        ]"
        @click="editable ? $emit('goToSummary') : null"
      >
        <i v-if="step7 || finishedStep" class="fas fa-check" />
        <i v-else class="number">6</i>
        <p>Bestellübersicht</p>
      </li>
      <li
        :class="[
          'arrow',
          { 'half-active': step6, 'active': step7 },
        ]"
      />

      <li
        :class="[
          'step step-five', {
            passed: step7
          }
        ]"
      >
        <i v-if="step7 || finishedStep" class="fas fa-check" />
        <i v-else class="number">7</i>
        <p>Fertig!</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["currentOrderStep", "editable"],
  computed: {
    step1() {
      return this.currentOrderStep === "1";
    },
    step2() {
      return this.currentOrderStep === "2a"; 
    },
    step21() {
      return this.currentOrderStep === "2b";
    },
    step3() {
      return this.currentOrderStep === "3";
    },
    step4() {
      return this.currentOrderStep === "4a";
    },
    step41() {
      return this.currentOrderStep === "4b";
    },
    step5() {
      return this.currentOrderStep === "5";
    },
    step6() {
      return this.currentOrderStep === "6";
    },
    step7() {
      return this.currentOrderStep === "7";
    },
    step441() {
      return this.step4 || this.step41;
    },
    step567() {
      return this.step5 || this.step6 || this.step7 || this.finishedStep;
    },
    step67() {
      return this.step6 || this.step7 || this.finishedStep;
    },
    step45678() {
      return (
        this.step4 ||
        this.step41 ||
        this.step5 ||
        this.step6 ||
        this.step7 ||
        this.finishedStep
      );
    },
    step345678() {
      return (
        this.step3 ||
        this.step4 ||
        this.step41 ||
        this.step5 ||
        this.step6 ||
        this.step7 ||
        this.finishedStep
      );
    },
    step2345678() {
      return (
        this.step2  ||
        this.step21 ||
        this.step3  ||
        this.step4  ||
        this.step41  ||
        this.step5  ||
        this.step6  ||
        this.step7  ||
        this.finishedStep
      );
    },
    finishedStep() {
      return this.currentOrderStep === "finished" || !this.currentOrderStep;
    },
  },
  watch: {
    currentOrderStep () {
      const that = this;
      setTimeout(that.scrollToActiveStep, 800);
    },
  },
  methods: {
    isStepInViewport(el) {
      // Source https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport
      const rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      );
    },
    scrollToActiveStep() {
      const activeEl = document.querySelector(".step.active:not(.passed)");
      
      if (!this.isStepInViewport(activeEl) && activeEl) {
        const container = document.querySelector(".checkout-process");
        let containerScroll = container.scrollLeft + 50;
        containerScroll += 100;
        container.scroll(containerScroll, 0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.checkout-process {
  overflow: auto;
  scroll-behavior: smooth;
  background-color: #e5e5e5;
  box-shadow: 0 0.125rem 0.3125rem -0.3125rem rgba(0, 0, 0, 0.15);
  padding-bottom: 10px;
  @include breakpoint(desktop) {
    overflow: hidden;
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 670px;
    margin: 0 auto;
    padding: 0.8125rem 0.625rem 1.875rem;
    li {
      position: relative;
      display: flex;
      align-items: center;
      &.clickable {
        cursor: pointer;
      }
      &.step-one {
        p {
          //width: 70px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      &.step-two {
        p {
          //width: 70px;
          left: 50%;
          transform: translateX(-50%);

          @include breakpoint(desktop) {
            //left: -14px;
          }
        }
      }
      &.step-three {
        p {
          //width: 75px;
          left: 50%;
          transform: translateX(-50%);
          @include breakpoint(desktop) {
            bottom: -1.25rem;
          }
        }
      }
      &.step-four {
        p {
          left: 50%;
          transform: translateX(-50%);
          @include breakpoint(desktop) {
            //left: -37px;
          }
        }
      }
      .fa-ellipsis-h {
        background-color: $red;
        color: $white;
      }
      &.step {
        border-right: 0.125rem solid #e5e5e5;
        border-left: 0.125rem solid #e5e5e5;
      }
      &.arrow {
        width: 40%;
        height: 0.25rem;
        background-color: #d8d8d8;
        &.active {
          background-color: $red;
        }
        &.half-active {
          position: relative;
          &:after {
            content: "";
            position: absolute;
            height: 0.25rem;
            width: 50%;
            background-color: $red;
          }
        }
      }
      i {
        font-size: 0.75rem;
        padding: 0.3125rem 0.3125rem;
        border-radius: 50%;
        color: $white;
      }
      p {
        position: absolute;
        bottom: -1.25rem;
        left: 0;
        font-size: 10px;
        white-space: nowrap;
      }
      .number {
        font-style: normal;
        font-weight: bold;
        padding: 0.3125rem 0.5625rem;
        background-color: #d8d8d8;
      }
      &.active-number {
        .number {
          font-style: normal;
          padding: 0.3125rem 0.5625rem;
          font-weight: 700;
          border-color: $red;
          color: $red;
        }
      }
      &.passed {
        i {
          border-color: $red;
          background-color: $red;
          color: $white;
        }
        .fa-check {
          font-size: 0.75rem;
        }
        p {
          font-weight: 700;
          color: $red;
        }
      }
      &.active {
        p {
          font-weight: 700;
          opacity: 1;
          color: $black;
        }
        .number {
          background-color: $red;
        }
      }
      &.pending {
        i {
          padding: 0.125rem;
          border-color: $red;
          background-color: $red;
          color: $white;
        }
        .fa-clock {
          font-size: 1.375rem;
        }
      }
    }
  }
  @include breakpoint(tablet) {
    ul {
      li {
        &.step-five {
          p {
            left: -15px;
          }
        }
      }
    }
  }
  @include breakpoint(medium) {
    background: $white;

    ul li {
      &.step {
        border-right: 0.125rem solid $white;
        border-left: 0.125rem solid $white;
      }

      p {
        font-size: 13px;
      }
    }
  }

  @include breakpoint(desktop) {
    ul {
      margin-bottom: 3rem;
      padding: 0;
      li {
        &.zero-step {
          display: flex;
          p {
            font-weight: 700;
          }
        }
        p {
          font-size: 0.875rem;
        }
      }
    }
  }
}
</style>
